// Variables
vs-text-image {
  --primary-color: #161616;
  --secondary-color: #666666;
  --border-color: rgba(24, 24, 27, 0.1);
  --neutral-bg: rgb(245, 245, 245);
  --white: #ffffff;
  --transition-duration: 0.3s;
  --transition-easing: cubic-bezier(0.25, 0.46, 0.45, 0.94);
  --border-radius-pill: 1000px;
  --border-radius-tab: 56px;
  --font-family: "Visa Dialect", sans-serif;
  --animation-time: 600ms;
  --fullbleed-dissolve-time: 400ms;
  --mask-color: rgba(255, 204, 0, 0.8);

  display: block;
  font-family: var(--font-family);
  box-sizing: border-box;
}

// :host {
//   --primary-color: #161616;
//   --secondary-color: #666666;
//   --border-color: rgba(24, 24, 27, 0.1);
//   --neutral-bg: rgb(245, 245, 245);
//   --white: #ffffff;
//   --transition-duration: 0.3s;
//   --transition-easing: cubic-bezier(0.25, 0.46, 0.45, 0.94);
//   --border-radius-pill: 1000px;
//   --border-radius-tab: 56px;
//   --font-family: "Visa Dialect", sans-serif;
//   --animation-time: 600ms;
//   --fullbleed-dissolve-time: 400ms;
//   --mask-color: rgba(255, 204, 0, 0.8);

//   display: block;
//   font-family: var(--font-family);
//   box-sizing: border-box;
// }

// Theme-specific color variables
.visa-text-image-theme-light {
  --text-primary: #1a1a1a;
  --text-secondary: #656565;
  --text-eyebrow: #1a1a1a;
  --button-primary-bg: #161616;
  --button-primary-text: #ffffff;
  --button-primary-hover: #333333;
  --button-secondary-bg: transparent;
  --button-secondary-text: #161616;
  --button-secondary-hover: #333333;
  --tab-text: #161616;
  --tab-text-active: #ffffff;
  --tab-bg-active: #161616;
  --tab-border: rgba(24, 24, 27, 0.1);
  --tab-hover-bg: rgb(249, 250, 251);
  --layout-bg: #ffffff;
}

.visa-text-image-theme-dark {
  --text-primary: #ffffff;
  --text-secondary: rgba(255, 255, 255, 0.8);
  --text-eyebrow: #ffffff;
  --button-primary-bg: #ffffff;
  --button-primary-text: #161616;
  --button-primary-hover: #f0f0f0;
  --button-secondary-bg: transparent;
  --button-secondary-text: #ffffff;
  --button-secondary-hover: rgba(255, 255, 255, 0.1);
  --tab-text: #ffffff;
  --tab-text-active: #161616;
  --tab-bg-active: #ffffff;
  --tab-border: rgba(255, 255, 255, 0.3);
  --tab-hover-bg: rgba(255, 255, 255, 0.1);
  --layout-bg: #1a1a1a;
}

*,
*:before,
*:after {
  box-sizing: inherit;
}

// Base component wrapper
.visa-text-image {
  width: 100%;
  height: auto;
}

// Media elements (images and videos)
.visa-text-image-media-element {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

// Hide poster during transitions to prevent flashing
.visa-text-image-media-element.slide-in .vsr-video-wrapper.show-poster::before,
.visa-text-image-media-element.slide-out .vsr-video-wrapper.show-poster::before,
.visa-text-image-media-element.slide-left .vsr-video-wrapper.show-poster::before,
.visa-text-image-media-element.slide-right .vsr-video-wrapper.show-poster::before {
  opacity: 0 !important;
}

.visa-text-image-video-wrapper {
  width: 100%;
  height: 100%;
  display: block;

  vsr-video {
    width: 100%;
    height: 100%;
    display: block;
  }
}

.vs-text-image-video-container {
  width: 100%;
  height: 100%;
  position: relative;

  vsr-video {
    width: 100%;
    height: 100%;
    display: block;
  }
}

// Split layout (cropped format)
.visa-text-image-split-layout {
  display: flex;
  align-items: flex-start;
  height: 100vh;
  padding: 80px;
  background-color: var(--layout-bg);
  position: relative;
  overflow: hidden; /* Important for the background wipe effect */

  &.visa-text-image-reversed {
    flex-direction: row-reverse;
  }

  @media (max-width: 1024px) {
    height: 576px;
    padding: 40px;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    height: auto;
    padding: 24px;

    &.visa-text-image-reversed {
      flex-direction: column;
    }
  }

  /* Background color overlay for wipe effect */
  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: transparent;
    z-index: 0;
    transition: transform var(--animation-time) ease;
    transform: translateX(-100%);
  }

  /* When transitioning, show the overlay with the new color */
  &.transitioning::before {
    transform: translateX(0);
  }

  /* Direction-specific animations */
  &.left-to-right::before {
    transform: translateX(-100%);
  }

  &.left-to-right.transitioning::before {
    transform: translateX(0);
  }

  &.right-to-left::before {
    transform: translateX(100%);
  }

  &.right-to-left.transitioning::before {
    transform: translateX(0);
  }
}

.visa-text-image-split-layout.yellow {
  background-color: #ffee9a;
}

.visa-text-image-split-layout.blue {
  background-color: #c7edff;
}

.visa-text-image-split-layout.green {
  background-color: #d6f1c4;
}

.visa-text-image-split-layout.brown {
  background-color: #322b22;
}

.visa-text-image-split-layout {
  &:has(.visa-text-image-active.yellow) {
    background-color: #ffee9a;
    &::before {
      background-color: #ffee9a;
    }
  }
  &:has(.visa-text-image-active.green) {
    background-color: #d6f1c4;
    &::before {
      background-color: #d6f1c4;
    }
  }
  &:has(.visa-text-image-active.blue) {
    background-color: #c7edff;
    &::before {
      background-color: #c7edff;
    }
  }
  &:has(.visa-text-image-active.brown) {
    background-color: #322b22;
    &::before {
      background-color: #322b22;
    }
  }
}

// Media container
.visa-text-image-media-container {
  position: relative;
  height: 100%;
  flex: 1;

  @media (max-width: 768px) {
    width: 100%;
    height: 400px;
    min-height: 400px; // Ensure minimum height is maintained
    display: block; // Ensure proper display mode
  }
}

// Media content wrapper - intermediate div to maintain aspect ratio
.visa-text-image-media-wrapper {
  position: absolute;
  right: 0;
  aspect-ratio: 4/5;
  overflow: hidden;
  height: 100%;
  max-width: 100%;
  @media (max-width: 768px) {
    width: 100%;
    height: 100%;
    display: block; // Ensure proper display mode
    position: relative;
  }
}

// Image elements for slide transitions
.visa-text-image-media-wrapper .visa-text-image-media-element {
  position: absolute;
  top: 0;
  height: 100%;
  width: auto;
  aspect-ratio: 4/5;
  background-size: cover;
  background-position: center;
  transition: transform var(--animation-time) ease;

  @media (max-width: 768px) {
    position: absolute; // Reinforce absolute positioning
    height: 100%;
    object-fit: cover; // Ensure image covers the area properly
  }

  // Position elements for animation
  &.previous {
    z-index: 1;
  }

  &.current {
    z-index: 1;
  }

  // Slide animations
  &.slide-in {
    animation: slideIn var(--animation-time) ease forwards;

    &.slide-left {
      animation-name: slideInFromRight;
    }

    &.slide-right {
      animation-name: slideInFromLeft;
    }
  }

  &.slide-out {
    animation: slideOut var(--animation-time) ease forwards;

    &.slide-left {
      animation-name: slideOutToLeft;
    }

    &.slide-right {
      animation-name: slideOutToRight;
    }
  }
}

// Content container
.visa-text-image-content-container {
  display: flex;
  flex-direction: column;
  gap: 32px;
  align-self: stretch;
  padding: 0rem 3rem 0rem 3rem;
  flex: 1 0 0%;
  justify-content: space-between;

  &.visa-text-image-aligned-end {
    align-items: flex-end;
  }

  &.visa-text-image-aligned-start {
    align-items: flex-start;
  }

  @media (max-width: 1024px) {
    gap: 24px;
  }

  @media (max-width: 768px) {
    padding: 2rem;
  }

  @media (max-width: 640px) {
    padding: 1.5rem;
  }
}

// Tab navigation
.visa-text-image-tab-nav {
  display: flex;
  gap: 0.5rem;
  align-items: center;
  justify-content: center;
  padding: 12px;
  border: 1px solid var(--tab-border);
  border-radius: var(--border-radius-pill);
  position: relative; /* Required for absolute positioning of the indicator */
  width: 100%; /* Ensure the nav takes full width */

  @media (max-width: 640px) {
    gap: 0.25rem;
    padding: 0.5rem;
  }

  /* Tab indicator for sliding animation */
  .visa-text-image-tab-indicator {
    position: absolute;
    top: 50%;
    left: 0;
    height: 2.5rem; /* Match the height of tab buttons */
    transform: translateY(-50%); /* Center vertically */
    background-color: var(--tab-bg-active);
    border-radius: var(--border-radius-tab);
    z-index: 0;
    transition: transform var(--animation-time) var(--transition-easing);
    pointer-events: none; /* Allow clicks to pass through to buttons */

    &.animating {
      transition: transform var(--animation-time) var(--transition-easing);
    }

    @media (max-width: 640px) {
      height: 2.25rem; /* Match the smaller height for mobile */
    }
  }
}

.visa-text-image-tab-button {
  display: flex;
  gap: 0.5rem;
  justify-content: center;
  align-items: center;
  padding: 0.875rem 1rem;
  height: 2.5rem;
  cursor: pointer;
  border-radius: var(--border-radius-tab);
  border: none;
  background: transparent;
  transition: all var(--transition-duration) ease-in-out;
  position: relative; /* For proper z-index stacking */
  z-index: 1; /* Ensure button is above the indicator */
  flex: 1; /* Make all buttons take equal width */
  min-width: 0; /* Allow buttons to shrink if needed */

  &:hover:not(.visa-text-image-active) {
    background-color: var(--tab-hover-bg);
  }

  &.visa-text-image-active {
    background-color: transparent; /* Remove background as indicator will show instead */

    .visa-text-image-tab-label {
      color: var(--tab-text-active);
      position: relative;
      z-index: 2; /* Ensure text is visible above the indicator */
    }
  }

  @media (max-width: 640px) {
    padding: 0.75rem 0.875rem;
    height: 2.25rem;
  }
}

.visa-text-image-tab-label {
  font-size: 0.75rem;
  font-weight: 500;
  line-height: 1rem;
  text-align: center;
  color: var(--tab-text);
  width: 100%; /* Ensure label takes full width of the button */
  min-width: 0; /* Allow text to shrink if needed */
}

// Tab navigation visibility
.visa-text-image-tab-nav-mobile {
  display: none;

  @media (max-width: 768px) {
    display: block;
    width: 100%;
    padding: 3rem;
    justify-content: center;
  }

  @media (max-width: 640px) {
    padding: 1rem;
  }
}

.visa-text-image-tab-nav-desktop {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  align-items: flex-start;
  width: 416px;

  @media (max-width: 1024px) {
    width: 100%;
  }

  @media (max-width: 768px) {
    display: none;
  }
}

// Content block
.visa-text-image-content-block {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  align-items: flex-start;
  width: 416px;

  &.visa-text-image-fullbleed {
    align-items: flex-start;
    text-align: left;
  }

  @media (max-width: 1024px) {
    width: 100%;
  }

  @media (max-width: 768px) {
    &.visa-text-image-fullbleed {
      align-items: flex-start;
      text-align: left;
    }
  }
  &:focus-visible {
    outline: none;
  }
}

.visa-text-image-headline {
  font-size: 52px;
  font-style: normal;
  font-weight: 400;
  line-height: 110%; /* 57.2px */
  letter-spacing: -0.52px;
  margin: 0;
  color: var(--text-primary);
  // overflow: hidden;
  text-overflow: ellipsis;
  font-family: "Visa Dialect", sans-serif;

  @media (max-width: 1024px) {
    font-size: 32px;
    line-height: 115%; /* 36.8px */
  }

  @media (max-width: 640px) {
    font-size: 32px;
    line-height: 115%; /* 36.8px */
  }
}

.visa-text-image-description {
  margin: 0;
  color: var(--text-secondary);
  font-family: "Visa Dialect", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%; /* 19.6px */
}

// Button group
.visa-text-image-button-group {
  display: flex;
  gap: 1rem;
  align-items: center;
  margin-top: 0.5rem;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 1rem;
    width: 100%;
  }
}

.visa-text-image-primary-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: var(--button-primary-bg);
  color: var(--button-primary-text);
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
  padding: 0.75rem 1.5rem;
  border-radius: var(--border-radius-pill);
  text-decoration: none;
  transition: background-color var(--transition-duration) ease;
  border: none;
  cursor: pointer;
  font-family: var(--font-family);

  &:hover {
    background-color: var(--button-primary-hover);
  }
}

.visa-text-image-link-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: var(--button-secondary-text);
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
  text-decoration: none;
  padding: 0.75rem 0;
  transition: color var(--transition-duration) ease;
  border: none;
  background: var(--button-secondary-bg);
  cursor: pointer;
  font-family: var(--font-family);

  &:hover {
    color: var(--button-secondary-hover);
    text-decoration: underline;
  }
}

// Eyebrow text
.visa-text-image-eyebrow-text {
  font-size: 12px;
  font-weight: 500;
  margin-bottom: 1.5rem;
  letter-spacing: 0.05em;
  color: var(--text-eyebrow);
  @media (max-width: 1024px) {
    //margin-bottom: 1.5rem;
  }
}

.visa-text-image-eyebrow-mobile {
  display: none;

  @media (max-width: 768px) {
    display: block;
    width: 100%;

    .visa-text-image-eyebrow-text {
      // margin-bottom: 1.5rem;
    }
  }
}

// Full-bleed layout
.visa-text-image-fullbleed-layout {
  position: relative;
  height: 810px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;

  &.visa-text-image-transitioning {
    // Transition state styles if needed
  }

  @media (max-width: 1024px) {
    height: 576px;
  }

  @media (max-width: 768px) {
    height: 812px;
  }
}

.visa-text-image-fullbleed-media {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;

  .visa-text-image-media-wrapper {
    width: 100%;
    height: 100%;
    aspect-ratio: auto; /* Override the 4/5 aspect ratio for fullbleed layout */

    .visa-text-image-media-element {
      width: 100%; /* Ensure the image covers the full width */
      height: 100%;
      object-fit: cover;
      aspect-ratio: auto; /* Override the 4/5 aspect ratio for fullbleed layout */
      transition: opacity var(--fullbleed-dissolve-time) ease;

      &.dissolve-in {
        animation: dissolveIn var(--fullbleed-dissolve-time) ease forwards;
      }

      &.dissolve-out {
        animation: dissolveOut var(--fullbleed-dissolve-time) ease forwards;
      }
    }
  }
}

.visa-text-image-fullbleed-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  transition: background-color 1.2s var(--transition-easing);
}

.visa-text-image-fullbleed-content-wrapper {
  display: flex;
  height: 100%;
  width: 100%;
  z-index: 10;
  position: relative;

  &.visa-text-image-reversed {
    flex-direction: row-reverse;
  }

  @media (max-width: 768px) {
    justify-content: center;

    &.visa-text-image-reversed {
      flex-direction: column;
    }
  }
}

.visa-text-image-fullbleed-spacer {
  flex: 1;

  @media (max-width: 768px) {
    display: none;
  }
}

.visa-text-image-fullbleed-content-area {
  flex: 1;
  display: flex;
  align-items: top;
  justify-content: flex-start;
  padding: 5rem;

  @media (max-width: 1024px) {
    padding: 2.5rem;
  }

  @media (max-width: 768px) {
    width: 100%;
    justify-content: flex-start;
    padding: 1.5rem;
  }
}

// Orientation-based alignment for fullbleed content area
.visa-text-image-fullbleed-content-wrapper.visa-text-image-reversed
  .visa-text-image-fullbleed-content-area {
  justify-content: flex-start;

  @media (max-width: 768px) {
    justify-content: center;
  }
}

.visa-text-image-content-wrapper {
  display: flex;
  flex-direction: column;
  gap: 32px;
  align-items: flex-start;
  max-width: 56rem;
  backface-visibility: hidden;
  perspective: 1000px;

  @media (max-width: 1024px) {
    gap: 24px;
  }

  @media (max-width: 768px) {
    align-items: flex-start;
  }
}

.visa-text-image-fullbleed-nav-area {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  align-items: flex-start;

  @media (max-width: 768px) {
    width: 100%;
  }
}

// Fullbleed content styles
.visa-text-image-fullbleed-content {
  .visa-text-image-headline {
    font-size: 52px;
    font-style: normal;
    font-weight: 400;
    line-height: 110%; /* 57.2px */
    letter-spacing: -0.52px;
    margin: 0;
    color: var(--text-primary);
    // overflow: hidden;
    text-overflow: ellipsis;
    font-family: "Visa Dialect", sans-serif;

    @media (max-width: 1024px) {
      font-size: 32px;
      line-height: 115%; /* 36.8px */
    }

    @media (max-width: 640px) {
      font-size: 32px;
      line-height: 115%; /* 36.8px */
    }
  }

  .visa-text-image-description {
    color: var(--text-secondary);
  }

  .visa-text-image-eyebrow-text {
    color: var(--text-eyebrow);
  }

  // Tab navigation in fullbleed
  .visa-text-image-tab-button {
    color: var(--tab-text);
    border: 1px solid var(--tab-border);
    background-color: transparent;

    &:hover:not(.visa-text-image-active) {
      background-color: var(--tab-hover-bg);
      border-color: var(--tab-border);
    }

    &.visa-text-image-active {
      background-color: transparent; /* Remove background as indicator will show instead */
      border: 1px solid var(--tab-border);

      .visa-text-image-tab-label {
        color: var(--tab-text-active);
        position: relative;
        z-index: 2;
      }
    }
  }

  /* Tab indicator for fullbleed mode */
  .visa-text-image-tab-indicator {
    background-color: var(--tab-bg-active);
  }

  .visa-text-image-tab-label {
    color: var(--tab-text);
  }

  // Button group in fullbleed
  .visa-text-image-primary-button {
    background-color: var(--button-primary-bg);
    color: var(--button-primary-text);
    border: 1px solid var(--button-primary-bg);
    padding: 12px 24px;

    &:hover {
      background-color: var(--button-primary-hover);
    }
  }

  .visa-text-image-link-button {
    background-color: var(--button-secondary-bg);
    color: var(--button-secondary-text);
    border: 1px solid var(--button-secondary-text);
    padding: 12px 24px;
    border-radius: var(--border-radius-pill);

    &:hover {
      background-color: var(--button-secondary-hover);
      text-decoration: none;
    }
  }
}

// Content transitions
.visa-text-image-content-transition {
  transition: opacity 0.6s var(--transition-easing);
  will-change: opacity;

  &.visa-text-image-fade-out {
    opacity: 0;
  }

  &.visa-text-image-fade-in {
    opacity: 1;
  }
}

// Smooth animations
@keyframes smoothFadeIn {
  0% {
    opacity: 0;
    transform: scale(1.05);
    filter: blur(4px);
  }
  100% {
    opacity: 1;
    transform: scale(1);
    filter: blur(0px);
  }
}

.visa-text-image-fullbleed-layout {
  animation: smoothFadeIn 1.5s var(--transition-easing);
}

// Smooth text transitions for fullbleed
.visa-text-image-fullbleed-content {
  h1,
  p,
  button {
    transition: all 0.8s var(--transition-easing);
  }
}

// Mobile-specific adjustments
@media (max-width: 768px) {
  .visa-text-image-tab-nav {
    justify-content: center;
  }

  .visa-text-image-fullbleed-content {
    text-align: left;

    .visa-text-image-content-block {
      align-items: flex-start;
    }
  }
}

// Focus indicators for accessibility
.visa-text-image-tab-button:focus-visible {
  outline: 2px dotted #000000;
  outline-offset: 2px;
}

.visa-text-image-tab-button:focus {
  outline: 2px dotted #000000;
  outline-offset: 2px;
}

.visa-text-image-primary-button:focus-visible,
.visa-text-image-link-button:focus-visible {
  outline: 2px dotted #000000;
  outline-offset: 2px;
}

// Theme-aware focus indicators for fullbleed
.visa-text-image-theme-light .visa-text-image-fullbleed-content {
  .visa-text-image-tab-button:focus-visible,
  .visa-text-image-primary-button:focus-visible,
  .visa-text-image-link-button:focus-visible {
    outline: 2px dotted #000000;
    outline-offset: 2px;
  }
}

.visa-text-image-theme-dark .visa-text-image-fullbleed-content {
  .visa-text-image-tab-button:focus-visible,
  .visa-text-image-primary-button:focus-visible,
  .visa-text-image-link-button:focus-visible {
    outline: 2px dotted #ffffff;
    outline-offset: 2px;
  }
}

// High contrast mode support
@media (prefers-contrast: high) {
  :host {
    --border-color: rgba(0, 0, 0, 0.5);
  }

  .visa-text-image-tab-button {
    border: 2px solid var(--border-color);
  }

  // Enhanced focus indicators for high contrast mode
  .visa-text-image-tab-button:focus-visible,
  .visa-text-image-primary-button:focus-visible,
  .visa-text-image-link-button:focus-visible {
    outline: 3px solid #000000;
    outline-offset: 3px;
  }
}

// Animation keyframes for slide transitions
@keyframes slideInFromRight {
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);
  }
}

@keyframes slideInFromLeft {
  from {
    transform: translateX(-100%);
  }
  to {
    transform: translateX(0);
  }
}

@keyframes slideOutToLeft {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-100%);
  }
}

@keyframes slideOutToRight {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(100%);
  }
}

@keyframes maskReveal {
  0% {
    transform: scaleX(0);
  }
  50% {
    transform: scaleX(1);
  }
  100% {
    transform: scaleX(0);
    transform-origin: right;
  }
}

@keyframes dissolveIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes dissolveOut {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}

// Reduced motion support
@media (prefers-reduced-motion: reduce) {
  .visa-text-image-content-transition,
  .visa-text-image-tab-button,
  .visa-text-image-primary-button,
  .visa-text-image-link-button,
  .visa-text-image-media-element {
    transition: none;
    animation: none !important;
  }

  .visa-text-image-fullbleed-layout {
    animation: none;
  }

  .image-mask {
    display: none;
  }
}

.vs-text-image-container-light {
  --promotout-bg: #ffffff;
  --promotout-left-bg: #f7f7f7;
  --parent-bg: #f7f7f7;
  --text-color: #1a1a1a;
  --text-color-desc: #656565;
}

.vs-text-image-container-dark {
  --promotout-bg: #1a1a1a;
  --promotout-left-bg: #2c2c2c;
  --parent-bg: #2c2c2c;
  --text-color: #ffffff;
  --text-color-desc: #ffffff;
}

.vs-text-image-container.text-image {
  padding: 0;
  background-color: var(--promotout-bg);
  @media (min-width: 768px) {
    padding: 0;
  }
  & .vs-text-image-content-wrapper {
    background-color: transparent;
    align-items: flex-start;
  }
  & .vs-text-image-content-wrapper-title {
    padding: 24px 24px 48px 24px;
    width: auto;
    @media (min-width: 768px) {
      padding-left: 48px;
      max-width: none;
      margin: 0;
      width: 416px;
    }
  }
}

.vs-text-image-container {
  display: flex;
  align-items: stretch;
  background-color: var(--promotout-bg);
  padding: 24px;
  @media (min-width: 768px) {
    padding: 48px;
  }
}

.vs-text-image-container.media-left {
  flex-direction: column-reverse;
  @media (min-width: 768px) {
    flex-direction: row;
  }
}

.vs-text-image-container.media-right {
  flex-direction: column;
  @media (min-width: 768px) {
    flex-direction: row;
  }
}

.vs-text-image-content-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex-basis: 50%;
  background-color: var(--promotout-left-bg);
}

.vs-text-image-content-wrapper-title {
  max-width: 512px;
  margin: 0 auto;
  padding: 48px 32px;
  @media (min-width: 768px) {
    padding: 0px;
  }
}

.vs-text-image-image-container {
  flex-basis: 50%;
  background-position: center center;
  aspect-ratio: 4/3;
  background-size: cover;
}

.vs-text-image-video-container {
  flex-basis: 50%;
  height: auto;
  background-position: center center;
  aspect-ratio: 4/3;
  background-size: cover;
}

.vs-text-image-content-wrapper-left vsr-title {
  --vsr-title-bg: var(--parent-bg);
}

@media (max-width: 1024px) {
  .vs-text-image-container vsr-title .vsr-title-headline {
    font-size: 32px; /* Mobile and tablet font size */
  }
}
